function Color() {
    const layoutImage = {
        1: ['#aaadd6', '#bbbcdc', '#cfcfe5', '#ddddef'],
        2: ['rgb(0, 178, 157)', 'rgb(85, 197, 184)', 'rgb(160, 220, 213)', '#a8e2db'],
        3: ['#eb2f68', '#ff5186', '#ec7096', '#f1afc3'],
        4: ['#f6c63b', '#f7da86', '#fbe4a4', '#fbe4a2'],
        5: ['#71b560', '#9ccd90', '#bce3b2', '#c5e7bc']
    }

    const layoutLikes = {
        1: ['#aaadd6', '#bbbcdc', '#cfcfe5', '#ddddef'],
        2: ['rgb(0, 178, 157)', 'rgb(85, 197, 184)', 'rgb(160, 220, 213)', '#a8e2db'],
        3: ['#eb2f68', '#ff5186', '#ec7096', '#f1afc3'],
        4: ['#f6c63b', '#f7da86', '#fbe4a4', '#fbe4a2'],
        5: ['#71b560', '#9ccd90', '#bce3b2', '#c5e7bc']
    }

    const layoutText = {
        1: ['#aaadd6', '#bbbcdc', '#cfcfe5'],
        2: ['rgb(0, 178, 157)', 'rgb(85, 197, 184)', 'rgb(160, 220, 213)'],
        3: ['#eb2f68', '#ff5186', '#ec7096'],
        4: ['#f6c63b', '#f7da86', '#fbe4a4'],
        5: ['#71b560', '#9ccd90', '#bce3b2']
    }

    const bookCard1 = {
        1: ['#ffffff', '#dbe1ee', '#dbe1ee', '#d4d8ea', '#4768a9', '#697cb7', '#8994c5', '#abb3d5', '#d1d5e9'],
        2: ['#ececed', '#d5e2dd', '#c3dad0', '#f6f8f7', '#80bd9c', '#9ac8ae', '#b3d4c0', '#cbe1d3', '#e3efe7'],
        3: ['#ececed', '#e5d1d3', '#e0bbbe', '#f9f6f5', '#d4666c', '#da8482', '#e1a09c', '#ebbdb7', '#f4dcd8'],

        // copy of 2 & 3
        4: ['#ececed', '#d5e2dd', '#c3dad0', '#f6f8f7', '#80bd9c', '#9ac8ae', '#b3d4c0', '#cbe1d3', '#e3efe7'],
        5: ['#ececed', '#e5d1d3', '#e0bbbe', '#f9f6f5', '#d4666c', '#da8482', '#e1a09c', '#ebbdb7', '#f4dcd8']
    }

    const bookCard2 = {
        1: ['#c9d2e5', '#dbe1ee', '#edf0f6', '#4768a9'],
        2: ['#d7eae2', '#e6f2ec', '#f2f8f5', '#80bd9c'],
        3: ['#f0d1d3', '#f4e1e3', '#f9eff1', '#d4666c'],

        4: ['#d7eae2', '#e6f2ec', '#f2f8f5', '#80bd9c'],
        5: ['#f0d1d3', '#f4e1e3', '#f9eff1', '#d4666c']
    }

    const bookCard4 = {
        1: ['#4768a9', 'rgba(71,104,169,0.8)', 'rgba(71,104,169,0.6)', 'rgba(71,104,169,0.4)'],
        2: ['#80bd9c', 'rgba(128,189,156,0.8)', 'rgba(128,189,156,0.6)', 'rgba(128,189,156,0.4)'],
        3: ['#d4666c', 'rgba(212,102,108,0.8)', 'rgba(212,102,108,0.6)', 'rgba(212,102,108,0.4)'],
        // copy of 2 & 3
        4: ['#80bd9c', 'rgba(128,189,156,0.8)', 'rgba(128,189,156,0.6)', 'rgba(128,189,156,0.4)'],
        5: ['#4768a9', 'rgba(71,104,169,0.8)', 'rgba(71,104,169,0.6)', 'rgba(71,104,169,0.4)']
    }

    const bookCard5 = {
        1: ['#4768a9', '#bec7e0', '#dbe1ee'],
        2: ['#80bd9c', '#cfe6db', '#e6f2ec'],
        3: ['#d4666c', '#ecc7ca', '#f4e1e3'],
        // copy of 2 & 3
        4: ['#80bd9c', '#cfe6db', '#e6f2ec'],
        5: ['#d4666c', '#ecc7ca', '#f4e1e3']
    }

    const getColors = (cardType, cardGroup) => {
        let layout

        switch (cardType) {
            case 'layout image':
                layout = layoutImage
                break
            case 'layout likes':
                layout = layoutLikes
                break
            case 'layout text':
                layout = layoutText
                break
            case 'book card 1':
                layout = bookCard1
                break
            case 'book card 2':
                layout = bookCard2
                break
            case 'book card 4':
                layout = bookCard4
                break
            case 'book card 5':
                layout = bookCard5
                break
            default:
                break
        }

        return layout[cardGroup]
    }

    return {
        getColors
    }
}

export default Color



// WEBPACK FOOTER //
// ./client/app/common/color/color.factory.js